export default "__VITE_ASSET__I7Fa9BQy__"